// extracted by mini-css-extract-plugin
export default {"transWrp":"transaction_transWrp__J3Q9v","tabWrp":"transaction_tabWrp__JHV1V","dateWrapper":"transaction_dateWrapper__ly2YX"};